export default __webpack_public_path__ + "static/media/configuration-empty-icon.d3dab9c2.svg";